// Convert an ISO-3166 alpha-2 country code (e.g. "US") to its emoji flag.
export function codeToFlag(code) {
  if (!code || code.length !== 2 || code === "XX") return "🌐";
  const upper = code.toUpperCase();
  const A = 0x41;
  const REGIONAL = 0x1f1e6;
  const first = REGIONAL + (upper.charCodeAt(0) - A);
  const second = REGIONAL + (upper.charCodeAt(1) - A);
  return String.fromCodePoint(first, second);
}

export function formatDuration(seconds) {
  const s = Math.max(0, Math.round(Number(seconds) || 0));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const rem = s % 60;
  if (m < 60) return rem ? `${m}m ${rem}s` : `${m}m`;
  const h = Math.floor(m / 60);
  const mm = m % 60;
  return mm ? `${h}h ${mm}m` : `${h}h`;
}

export function formatRelative(iso) {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const diff = Math.floor((Date.now() - then) / 1000);
  if (diff < 5) return "just now";
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
